import utils from './../utils';
import namespace from './mappings/namespace';
import actions from './mappings/actions';
import state from './mappings/state';
import getters from './mappings/getters';
import mutations from './mappings/mutations';

const STORE = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
const PREFIX = 'mappings';

const NAMESPACE = utils.publishNamespace(PREFIX, namespace);

export {
    STORE,
    PREFIX,
    NAMESPACE
};


// WEBPACK FOOTER //
// ./src/store/modules/mappings.js